import styles from '../vacancy.module.scss'
import React from 'react'

const VacancyMainInfo = ({ vacancy }) => {
  const vacancyFullInfo = [
    { name: 'Shipowner:', value: vacancy.shipowner?.name || '—', isValueOptional: true },
    {
      name: 'Salary:',
      value:
        vacancy.salary && vacancy.salary_currency?.symbol && vacancy.salary_rate
          ? `${vacancy.salary} ${vacancy.salary_currency.symbol} on ${vacancy.salary_rate}`
          : null,
      isValueOptional: true,
    },
    { name: 'Salary description:', value: vacancy.salary_description, isValueOptional: true },
    { name: 'Description:', value: vacancy.description, isValueOptional: true },
    { name: 'Company Information:', value: vacancy.company_information, isValueOptional: true },
  ]

  return (
    <>
      {vacancyFullInfo.map(({ name, value }, index) => {
        if (!value) return null

        const isShipowner = name === 'Shipowner:'

        return (
          <div className={`${styles.vacancyField_short} ${isShipowner ? styles.shipowner : ''}`} key={index}>
            <p className={styles.vacancyFieldName}>{name}</p>
            <p
              className={`
                ${styles.vacancyFieldValue}
                ${styles.vacancyFieldValue__tooltip}
             
              `}
            >
              {value}
            </p>
          </div>
        )
      })}
    </>
  )
}

export default VacancyMainInfo
